import React, { useState } from "react";
import Header from "../../layout/Header";
import { decrypt } from "../../../utils/encodingdecoding";

// CryptoJS passphrase ciphers always start with base64("Salted__"), raw or URL-encoded
const CIPHER_PATTERN = /U2FsdGVkX1[A-Za-z0-9+/=%]+/g;

// Pulls the cipher out of whatever was pasted: raw cipher, { "data": "<cipher>" },
// nested/escaped JSON, DevTools "data: ..." copies, or text wrapped across lines
const extractCipher = (value) => {
    const cleaned = value.replace(/\\\//g, "/").replace(/\\/g, "").replace(/\s+/g, "");
    const matches = cleaned.match(CIPHER_PATTERN);
    if (matches) return matches.reduce((a, b) => (b.length > a.length ? b : a));
    return cleaned.replace(/^"|"$/g, "");
};

const decryptInput = (input) => {
    const value = input.trim();
    if (!value) return { output: "", error: "" };

    const plaintext = decrypt(extractCipher(value));
    if (!plaintext) {
        return { output: "", error: "Unable to decrypt. Check that the value is encrypted with the current secret key." };
    }

    try {
        return { output: JSON.stringify(JSON.parse(plaintext), null, 2), error: "" };
    } catch (error) {
        return { output: plaintext, error: "" };
    }
};

const DecryptPanel = ({ title }) => {
    const [input, setInput] = useState("");
    const [copied, setCopied] = useState(false);
    const { output, error } = decryptInput(input);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(output);
            setCopied(true);
            setTimeout(() => setCopied(false), 1500);
        } catch (err) {
            setCopied(false);
        }
    };

    return (
        <div className="col-lg-6 mb-4">
            <div className="d-flex justify-content-between align-items-center mb-2">
                <h5 className="mb-0">{title}</h5>
                <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => setInput("")} disabled={!input}>
                    Clear
                </button>
            </div>
            <label className="form-label">Encrypted</label>
            <textarea
                className="form-control mb-3"
                rows={8}
                placeholder='Paste cipher text or {"data": "..."}'
                value={input}
                onChange={(e) => setInput(e.target.value)}
                style={{ fontFamily: "monospace", fontSize: 13 }}
            />
            <div className="d-flex justify-content-between align-items-center mb-2">
                <label className="form-label mb-0">Decrypted</label>
                <button type="button" className="btn btn-sm btn-outline-primary" onClick={handleCopy} disabled={!output}>
                    {copied ? "Copied" : "Copy"}
                </button>
            </div>
            {error ? (
                <div className="alert alert-danger mb-0">{error}</div>
            ) : (
                <pre
                    className="form-control"
                    style={{ minHeight: 200, maxHeight: 500, overflow: "auto", whiteSpace: "pre-wrap", wordBreak: "break-word", fontSize: 13, background: "#f8f9fa" }}
                >
                    {output}
                </pre>
            )}
        </div>
    );
};

const DecryptTool = () => {
    return (
        <>
            <Header name={"Decrypt Tool"} />

            <div className="dashboard__content">
                <div className="container-fluid">
                    <div className="dashboard__customersCard">
                        <div className="dashboard__header">
                            <div className="dashboard__left">
                                <h4>Decrypt Request / Response</h4>
                            </div>
                        </div>

                        <div className="dashboard__body">
                            <div className="row">
                                <DecryptPanel title="Request Body" />
                                <DecryptPanel title="Response" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default DecryptTool;
